import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const user = authService.getUser();

    if (localStorage.getItem('currentUser') && user) {
        if (user._role === 'CLIENT' && user._token) {
            return true;
        } else if (user._role === 'ADMIN' && user._adminToken) {
            return true;
        } else {
            router.navigate(['/admin/login']);
            return false;
        }
    }

    router.navigate(['/login']);
    return false;
};

export const adminGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const user = authService.getUser();

    if (localStorage.getItem('currentUser') && user) {
        if (user._role === 'ADMIN') {
            return true;
        }
        router.navigate(['']);
        return false;
    }

    router.navigate(['/admin/login']);
    return false;
};
